<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      class="menu"
      :default-active="defaultActive"
      :collapse="isCollapse"
      background-color="#000000"
      text-color="#ffffff"
      :unique-opened="false"
      active-text-color="#ffffff"
      :collapse-transition="false"
      width="250px"
      mode="vertical"
    >
      <sidebar-item v-for="route in routes" :key="route.path" :base-path="basePath" :item="route" />
    </el-menu>
  </el-scrollbar>

</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SidebarItem from './sidebar-item';

export default {
  components: { SidebarItem },
  props: {
    basePath: {
      type: String,
      default: '',
      require: true,
    },
  },
  data() {
    return {
      defaultActive: this.$route.meta.activeMenu || this.$route.path,
    };
  },
  computed: {
    ...mapState('permission', [
      'routes',
    ]),
    ...mapGetters([
      'sidebar',
    ]),
    routes() {
      const routes = this.$store.state.permission.routes;
      const find = routes.find(route => route.path.startsWith(this.basePath));
      if (find) {
        return find.children;
      }
      return [];
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  watch: {
    '$route': {
      handler(val) {
        if (!val.hidden) {
          const route = this.$route;
          const { meta, path } = route;
          this.defaultActive = meta.activeMenu || path;
        }
      },
    },
  },

};
</script>

